import { makeStyles, Button } from '@material-ui/core'
import { PromptMode } from '../../models/Conversation.model'
import { memo } from 'react'
import { useAwsCredentialsManager } from '../../context/AWS-credentials.context'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
}))

type Props = {
  disabled: boolean
  mode: PromptMode
  onModeChange: (mode: PromptMode) => void
}

const ActionButtonsRow = ({ mode, onModeChange, disabled }: Props) => {
  const classes = useStyles()

  const { enableBidLibrary } = useAwsCredentialsManager()

  return (
    <div className={classes.container}>
      <Button
        variant={mode === 'DOCUMENT_ANALYSIS' ? 'contained' : 'outlined'}
        color="primary"
        onClick={() => onModeChange(PromptMode.DOCUMENT_ANALYSIS)}
        disabled={disabled}
      >
        Analyze
      </Button>

      <Button
        variant={mode === PromptMode.JOB_FOLDERS ? 'contained' : 'outlined'}
        color="primary"
        onClick={() => onModeChange(PromptMode.JOB_FOLDERS)}
        disabled={!enableBidLibrary}
      >
        Explore
      </Button>

      <Button
        variant={mode === PromptMode.DATA_ANALYTICS ? 'contained' : 'outlined'}
        color="primary"
        disabled
      >
        Visualize
      </Button>
    </div>
  )
}

export default memo(ActionButtonsRow)
